module.exports = __webpack_public_path__ + "static/image3@2x-46b1a87a549d9ba66775de53e92b9a5e.png";